import { Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse } from '@triare/auth-redux';
import { put, delay, takeLatest, call } from 'redux-saga/effects';
import { actions, ArticleStatus } from './index';
import { ArticleCreateBody } from './create';

export type ArticleUpdateData = {
  success: boolean;
};

export type ArticleUpdateResponse = ArticleUpdateData;

export interface ArticleUpdateBody extends Partial<ArticleCreateBody> {
  status?: ArticleStatus;
}

export interface ArticleUpdatePayload {
  id: string;
  body: ArticleUpdateBody
}

export const articleUpdate = (payload: ArticleUpdatePayload): Action<ArticleUpdatePayload> => ({
  type: actions.articleUpdateTrigger.toString(),
  payload,
});

export const articleUpdateClear = (): Action => ({
  type: actions.articleUpdateClear.toString(),
});

export const articleUpdateErrorClear = (): Action => ({
  type: actions.articleUpdateErrorReset.toString(),
});

export function* articleUpdateRequestSaga({ payload }: Action<ArticleUpdatePayload>) {
  yield put({
    type: actions.articleUpdateStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.articleUpdateError.toString(),
      payload: {
        message: 'ArticleUpdate: Parameters not passed.',
      },
    });

    return;
  }

  const { id, body } = payload;

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}admin/articles/${id}`,
    {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<ArticleUpdateData, ArticleUpdateResponse>(
    response,
    actions.articleUpdateSuccess.toString(),
    actions.articleUpdateError.toString(),
    false,
    (articleUpdateData) => articleUpdateData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.articleUpdateTrigger.toString(),
    defaultProcessingSaga(
      articleUpdateRequestSaga,
      {
        error: actions.articleUpdateError.toString(),
        locationCancel: actions.articleUpdateClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.articleUpdateSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }
  });

  yield takeLatest(actions.articleUpdateError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.articleUpdateErrorReset.toString(),
    });
  });
}
